var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 692,
    height: 796,
    viewBox: "0 0 692 796",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1103.42 1209.02C1028.38 1128.91 1017.05 1112.16 973.238 1034.56C962.502 1015.56 946.498 979.274 932.511 935.266C928.318 922.096 924.66 909.104 921.425 896.347C898.388 805.064 906.887 707.567 928.307 613.088C982.971 372.028 881.502 133.515 690.488 41.5621C499.121 -50.6149 262.068 24.3007 130.628 174.273C113.526 193.787 37.172 286.476 12.5237 396.382C-65.397 743.38 255.17 930.884 757.826 1108.95C767.605 1112.41 814.435 1126.92 824.408 1129.74L1103.46 1209.02L1103.42 1209.02Z",
    stroke: "black",
    strokeOpacity: 0.49,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape3.f90998f7ae5b93c42bde29d4500fb025.svg";
export { ForwardRef as ReactComponent };